// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vY-A","colBig":"styles_colBig__29yzZ","colSmall":"styles_colSmall__1QkTt","shopifyNameWrapper":"styles_shopifyNameWrapper__CU897"};